import {
  SAVE_COUNTRIES,
  SAVE_CURRENCIES,
  SAVE_INDUSTRIES,
  SAVE_TRADE_TERMS,
  SAVE_UNITS,
} from '../actions';

const defaultState = {
  industries: [],
  countries: {},
  currencies: [], // not in use
  units: [],
  tradeTerms: [],
};

export function constants(state = defaultState, action = null) {
  switch (action.type) {
    case SAVE_INDUSTRIES: {
      return {
        ...state,
        industries: action.industries,
      };
    }
    case SAVE_COUNTRIES: {
      return {
        ...state,
        countries: action.countries,
      };
    }
    case SAVE_CURRENCIES: {
      return {
        ...state,
        currencies: action.currencies,
      };
    }
    case SAVE_UNITS: {
      return {
        ...state,
        units: action.units,
      };
    }
    case SAVE_TRADE_TERMS: {
      return {
        ...state,
        tradeTerms: action.terms,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/constants.js